import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../assets/Icons";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import StatusContainer from "../../_utils/CommonStatus/StatusContainer";
import InfoCard from "../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";
import { resetBeneTxnMultiApprovalError } from "../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";

const FieldForceTransactionMultiApprovalError = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError } =
    useSelector((state) => state.beneTxnViewAccData);

  const actionType =
    BeneTxnMultiDeniedApprovalError && !BeneTxnMultiApprovalError
      ? "reject"
      : BeneTxnMultiApprovalError && !BeneTxnMultiDeniedApprovalError
        ? "approve"
        : "approve";

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
      dispatch(resetBeneTxnMultiApprovalError());
    };
  }, [dispatch]);

  const [ErrorPageData, setErrorPageData] = useState([]);

  const findCommonNames = (arr1, arr2) => {
    let type = arr2.some((item) => typeof item === "string");
    if (type) {
      return arr2;
    } else {
      const arr2Map = new Map(arr2?.map((item) => [item?.id, item?.errors]));

      return arr1
        .filter((item) => arr2Map?.has(item.txn_id))
        .map((item) => ({
          ...item,
          errors: arr2Map?.get(item.txn_id),
        }));
    }
  };
  const filterErrorTxn = findCommonNames(
    ErrorPageData,
    JSON.parse(sessionStorage.getItem("selectedDataError")) || [],
  );

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedData"),
    );

    if (storedSelectedApproval) {
      setErrorPageData(storedSelectedApproval?.selectedSendTransactions);
    } else {
      setErrorPageData([]);
    }
  }, []);

  const buttonRows = [
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/field_force_transaction_dashboard"),
        // handleFunction: () => {},
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const getTitle = () => {
    return actionType === "reject"
      ? "Oops! Transactions rejection failed"
      : "Oops! Transactions approval failed";
  };

  const getSubtitle = () => {
    const action = actionType === "reject" ? "rejection" : "approval";
    return `An error occurred with the following transactions, causing the ${action} of all the transaction to fail.`;
  };

  return (
    <div>
      <StatusContainer
        status="error"
        buttonRows={buttonRows}
        title={getTitle()}
        subtitle={getSubtitle()}
      >
        <TabsWeapperSection title="Error details">
          <>
            {Array.isArray(filterErrorTxn) &&
              filterErrorTxn.map((val, i) => {
                if (
                  typeof val === "string" &&
                  val.includes("No transactions found for transaction ids")
                ) {
                  return (
                    <InfoCard
                      bgColor="var(--negative-card)"
                      key={i}
                      rows={[
                        {
                          leftTitle: val,
                          leftSubTitle: "Error message",
                        },
                      ]}
                    />
                  );
                }
                return (
                  <>
                    {val.errors?.map((error, index) => (
                      <InfoCard
                        bgColor="var(--negative-card)"
                        key={index}
                        rows={[
                          {
                            leftTitle: error?.reason || error,
                            leftSubTitle: "Error message",
                          },
                        ]}
                      />
                    ))}
                  </>
                );
              })}
          </>
        </TabsWeapperSection>
        <TabsWeapperSection title="Transaction Details">
          <>
            {Array.isArray(filterErrorTxn) &&
              filterErrorTxn.map((val, i) => {
                if (typeof val === "string") return null;
                return (
                  <InfoCard
                    key={val.txn_id || i}
                    bgColor="var(--negative-card)"
                    onClick={() => {}}
                    hoverable="white"
                    rows={[
                      {
                        leftTitle: val.beneficiary_account_name,
                        leftSubTitle: "Account name",
                        hasRight: true,
                        rightText: true,
                        rightTitle: (
                          <>
                            INR <FormatAmount price={val?.amount} />
                          </>
                        ),
                        rightTitleTextColor: "var(--text-primary)",
                        rightTextFontWeight: "semibold",
                        rightSubTitle: "Amount",
                        rightIcon: true,
                      },
                    ]}
                  />
                );
              })}
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
};

export default FieldForceTransactionMultiApprovalError;
